import { render, staticRenderFns } from "./BetslipSummary.vue?vue&type=template&id=269c77db&"
import script from "./BetslipSummary.vue?vue&type=script&lang=js&"
export * from "./BetslipSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports